import { IApplicationState } from '../../types/redux';

/**
 * Выбирает топовую статью на Главной (0-ая позиция)
 */
export const selectTopMainArticle = ({ mainArticles }: IApplicationState) =>
  mainArticles.items.length ? mainArticles.items[0] : undefined;
